import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import { updatePrice } from '../../../../../actions/orders'

// Styles
import './index.scss'

// Utils
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../../utils/auth'
import { formatCurrency } from '../../../../../utils/currency'
import { translation } from '../../../../../utils/helpers'

// Elements
import Grid from '../../../../../shared/elements/grid'
import LabelWrapper from '../../../../../shared/elements/labelWrapper'

class PriceChange extends Component {
  constructor (props) {
    super(props)
    this.state = {
      pricelist: undefined
    }
    this.onInputChange = this.onInputChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.setState({
      pricelist: {
        Price: this.props.item.Price,
        Environment: this.props.item.Environment,
        AddonPrice: this.props.item.AddonPrice,
        AddonEnvironment: this.props.item.AddonEnvironment,
        PriceWP: this.props.item.PriceWP,
        EnvWP: this.props.item.EnvWP,
        AddonPriceWP: this.props.item.AddonPriceWP,
        AddonEnvWP: this.props.item.AddonEnvWP
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    let data = {
      Price: nextProps.item.Price,
      Environment: nextProps.item.Environment,
      AddonPrice: nextProps.item.AddonPrice,
      AddonEnvironment: nextProps.item.AddonEnvironment,
      PriceWP: nextProps.item.PriceWP,
      EnvWP: nextProps.item.EnvWP,
      AddonPriceWP: this.props.item.AddonPriceWP,
      AddonEnvWP: this.props.item.AddonEnvWP
    }

    if (!isEqual(data, this.state.pricelist)) {
      this.setState({
        pricelist: data
      })
    }
  }

  onInputChange (e) {
    let FixInput = e.target.value.replace(',', '.')

    e.persist()
    this.setState({
      pricelist: {
        ...this.state.pricelist,
        [e.target.name]: (e.target.type === 'checkbox') ? e.target.checked : FixInput
      }
    }, () => {
      if (e.target.type === 'checkbox') {
        this.onBlur()
      }
    })
  }

  onBlur () {
    let data = { ...this.state.pricelist }
    data.OrderId = this.props.id

    this.props.updatePrice(data).then((res) => {
      this.props.updateOrder(res.data)
      // Toastr
      // window.toastr.success(translation('2337'), translation('13424'))
    }, () => {
      // Toastr
      window.toastr.error(translation('960'), translation('216'))
    })

    this.props.close()
  }

  render () {
    if (this.state.pricelist === undefined) return null
    console.log('this.props.auth.user.UserType ', this.props.auth.user.UserType)
    let iswp = hasAccess([6], this.props.auth.user.UserType)
    const renderPriceLine = (key, value) => {
      return (
        <Grid cols={[1, 'min-content']} align='center'>
          <div>{translation(key)}</div>
          <div>{formatCurrency(value)}</div>
        </Grid>
      )
    }
    let three = 3
    if (/* this.props.item.HasOrderPrice !== true || this.props.item.MainReportDate !== null */ 2 + 2 !== three) {
      return (
        <div className='poppedup padding colorInlinePopup form'>
          <Grid cols={[1, 'min-content']} align='center'>
            <div>{translation('641')}</div>
            <div>{formatCurrency(this.state.pricelist.Price || 0)}</div>
          </Grid>
          <Grid cols={[1, 'min-content']} align='center'>
            <div>{translation('1044')}</div>
            <div>{formatCurrency(this.state.pricelist.Environment || 0)}</div>
          </Grid>
          {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<Grid cols={[1, 'min-content']} align='center'>
            <div>{translation('2325')}</div>
            <div>{formatCurrency(this.state.pricelist.AddonPrice || 0)}</div>
          </Grid>)}
          {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<Grid cols={[1, 'min-content']} align='center'>
            <div>{translation('2326')}</div>
            <div>{formatCurrency(this.state.pricelist.AddonEnvironment || 0)}</div>
          </Grid>)}
          {iswp && (
            <LabelWrapper labelText={translation('12270')}>
              {renderPriceLine('641', this.state.pricelist.PriceWP)}
              {renderPriceLine('1044', this.state.pricelist.EnvWP)}
              {renderPriceLine('2325', this.state.pricelist.AddonPriceWP)}
              {renderPriceLine('2326', this.state.pricelist.AddonEnvWP)}
            </LabelWrapper>
          )}
        </div>
      )
    }
    // not shown anymore

    //  else if (!hasAccess([4], this.props.auth.user.UserType)) {
      // return (
      //   <div className='poppedup padding colorInlinePopup form'>
      //     <div>
      //       <label>{translation('641')}</label>
      //       <input type='text' name='Price' value={this.state.pricelist.Price || ''} onChange={this.onInputChange} />
      //     </div>
      //     <div>
      //       <label>{translation('1044')}</label>
      //       <input type='text' name='Environment' value={this.state.pricelist.Environment || ''} onChange={this.onInputChange} />
      //     </div>
      //     {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<div>
      //       <label>{translation('2325')}</label>
      //       <input type='text' name='AddonPrice' value={this.state.pricelist.AddonPrice || ''} onChange={this.onInputChange} />
      //     </div>)}
      //     {(hasSubscriptionPermission(this.props.auth, 30) || hasPartnerSubscriptionPermission(this.props.auth, 30)) && (<div>
      //       <label>{translation('2326')}</label>
      //       <input type='text' name='AddonEnvironment' value={this.state.pricelist.AddonEnvironment || ''} onChange={this.onInputChange} />
      //     </div>)}
      //     <div>
      //       <button className='button primary' onClick={this.onBlur} style={{width: 250}}>{translation('Gem')}</button>
      //     </div>
      //   </div>
      // )
    // }
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  updatePrice
})(PriceChange)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/PriceChange/index.js